import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useGridApiContext, useGridSelector, gridPageSelector, gridPageSizeSelector } from '@mui/x-data-grid-premium';
import { Pagination } from '@cognite/cogs-core';

var DataGridPagination = function DataGridPagination(_a) {
  var pageSizeOptions = _a.pageSizeOptions,
    rowCount = _a.rowCount,
    rest = __rest(_a, ["pageSizeOptions", "rowCount"]);
  var apiRef = useGridApiContext();
  /**
   * not gonna use the selector now.
   * ref here for futher debugging - https://github.com/mui/mui-x/issues/8450
   */
  // const pageCount = useGridSelector(apiRef, gridPageCountSelector);
  var page = useGridSelector(apiRef, gridPageSelector);
  var pageSize = useGridSelector(apiRef, gridPageSizeSelector);
  var totalPages = rowCount ? Math.ceil(rowCount / pageSize) : 1;
  return jsx("div", {
    className: "cogs-datagrid-pagination-container",
    children: jsx(Pagination, Object.assign({}, rest, {
      className: "cogs-datagrid-pagination",
      currentPage: page + 1,
      totalPages: totalPages,
      setItemPerPage: function setItemPerPage(pageSize) {
        return apiRef.current.setPageSize(pageSize);
      },
      onPageChange: function onPageChange(newPage) {
        return apiRef.current.setPage(newPage - 1);
      },
      pageSizeOptions: pageSizeOptions,
      itemsPerPage: pageSize
    }))
  });
};

export { DataGridPagination };
